
<!-- Main Toolbar -->
<div class="relative flex items-center p-4 shadow-md" [ngClass]="cssService.toolbarBgClass">

  <!-- Bouton à gauche -->
  <div *ngIf="(currPos || userKey || id_merchant)">
    <button (click)="tools.goProductPage()"
      [ngClass]="cssService.backButton">
      <i class="material-icons text-sm">keyboard_arrow_left</i>
      <span class="text-sm"><span>{{'spaceOrder'|translate}} </span></span>
    </button>
  </div>

  <!-- Icône au centre -->
  <div *ngIf="!domainUser" class="hidden sm:block">
    <div class="absolute inset-0 flex justify-center items-center pointer-events-none">
      <img src="assets/img/refonte-logo/logo_myfulle.png" class="h-8 w-auto">
    </div>
  </div>

</div>

<div class="mt-8 mb-4">

  <!-- Icône au centre -->
  <div *ngIf="!domainUser" class="sm:hidden">
    <div class="flex flex-col items-center p-8">
      <img src="assets/img/refonte-logo/logo_myfulle.png" class="h-10 w-auto">
    </div>
  </div>

  <!-- Toogle Button / Login & Register -->
  <div class="flex justify-center ">

    <div class="inline-flex rounded-full border border-gray-300 overflow-hidden">
      <button (click)="authManPag.moveToLogin()"
              [ngClass]="(currComp$ === 'login' || currComp$ === 'forgotpass') ? cssService.authButtonToggleSelected : cssService.authButtonToggle">
        {{'main.word.login'|translate }}
      </button>
      <button (click)="authManPag.moveToRegister()" [ngClass]="currComp$ === 'register' ? cssService.authButtonToggleSelected : cssService.authButtonToggle">
        {{'main.word.register'|translate }}
      </button>
    </div>
  </div>

</div>
